import { render, staticRenderFns } from "./Locality.vue?vue&type=template&id=46da8071"
import script from "./Locality.vue?vue&type=script&lang=js"
export * from "./Locality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports